import { firestoreDefaultConverter } from 'vuefire'

import type { DocumentData, QueryDocumentSnapshot, SnapshotOptions } from 'firebase/firestore'
import type { DSComment } from '@/types'

export default function converter() {
  const { toDateString } = useDateHelper()

  return {
    toFirestore: firestoreDefaultConverter.toFirestore,
    fromFirestore: (snapshot: QueryDocumentSnapshot<DSComment, DocumentData>, options?: SnapshotOptions) => {
      const data = firestoreDefaultConverter
        .fromFirestore(snapshot, options) as DSComment

      data.createdDate = toDateString(data.created)
      data.updatedDate = toDateString(data.updated)

      return data
    },
  }
}
